import { clamp, defaults } from "lodash-es";

// 这些方法是个 designtool、actionbar 和 propPanel 用的，注意需要bind this

export function addTabPane(comp) {
  defaults(comp, {
    children: [],
    props: {}
  });
  comp.children.push({
    type: 'w-tab-pane',
    props: {
      title: '未命名页卡'
    },
    componentId: `wTabPane${Date.now().toString(36).slice(-8)}`
  });
  return comp.children.length - 1;
}
export function deleteTabPane(comp, deleteIndex) {
  var _comp$children;
  if (typeof deleteIndex !== 'number') return;
  if (!((_comp$children = comp.children) !== null && _comp$children !== void 0 && _comp$children.length)) return;
  defaults(comp, {
    props: {}
  });
  const index = clamp(deleteIndex, 0, comp.children.length - 1);
  comp.children.splice(index, 1);
  // eslint-disable-next-line no-param-reassign
  comp.props.cur = Math.min(+comp.props.cur || 0, comp.children.length - 1);
}